module.exports = __webpack_public_path__ + "img/sign-up-img-1@x2.d75ddc1.png";